var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8792 13.5982L21 15.7208L15.3601 21.3623C11.8463 24.8792 6.14922 24.8792 2.63538 21.3623C-0.87846 17.8455 -0.87846 12.1435 2.63538 8.62661L9.3512 1.90497C11.889 -0.63499 16.0035 -0.63499 18.5413 1.90497C21.0791 4.44494 21.0791 8.56304 18.5413 11.103L12.1789 17.4709C10.6172 19.0339 8.0852 19.0339 6.52349 17.4709C4.96179 15.9078 4.96179 13.3736 6.52349 11.8105L11.8099 6.5228L13.9307 8.64542L8.6443 13.9332C8.25385 14.3239 8.25385 14.9575 8.6443 15.3482C9.0347 15.739 9.6677 15.739 10.0581 15.3482L16.4205 8.98038C17.787 7.61271 17.787 5.39527 16.4205 4.0276C15.054 2.65992 12.8385 2.65992 11.472 4.0276L4.75617 10.7492C2.41361 13.0938 2.41361 16.8951 4.75617 19.2397C7.09873 21.5843 10.8968 21.5843 13.2393 19.2397L18.8792 13.5982Z",
    fill: "#E75B32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvUpload);
export default __webpack_public_path__ + "static/media/cv-upload.a5de60a7.svg";
export { ForwardRef as ReactComponent };